import React from 'react';
import Loadable from 'react-loadable';

import LoadingSpinner from '../../../../components/loading_spinner/loading_spinner';

let Component = false;

if (process.env.RUNTIME_ENV !== 'browser') {
  // eslint-disable-next-line global-require
  Component = require('../sponsored_tag_page_custom').default;
}

export default function(store) {
  const routeConfig = {
    path: '/section/urban-x',
    component() {
      if (Component) {
        return <Component />;
      }

      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    loadData: Component ? Component.loadData(store, 'urban-x') : false,
    preloadChunk() {
      return import(/* webpackChunkName: "sponsoredTagCustomPage" */ '../sponsored_tag_page_custom').then(
        resp => {
          Component = resp.default;
          routeConfig.loadData = Component.loadData(store, 'urban-x');
          return Component;
        }
      );
    },
    chunk: 'sponsoredTagCustomPage'
  };

  const LazyComponent = Loadable({
    loader() {
      return routeConfig.preloadChunk();
    },
    loading() {
      return (
        <section className="search">
          <LoadingSpinner />
        </section>
      );
    }
  });

  return routeConfig;
}
